import { apiFetch } from './client';
export async function listBoards() {
    const data = await apiFetch('/boards');
    return data.items;
}
export async function getBoardFull(boardId) {
    return apiFetch(`/boards/${boardId}/full`);
}
export async function createBoard(payload) {
    return apiFetch('/boards', {
        method: 'POST',
        body: JSON.stringify({
            ...payload,
            weeksCount: payload.weeksCount ?? 26,
        }),
    });
}
export async function patchBoard(boardId, payload) {
    return apiFetch(`/boards/${boardId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    });
}
